import React from 'react';
import { useSelector } from 'react-redux';

import LiveChallengesBar from '../../components/challenges/LiveChallengesBar';
import Responsive from '../../components/responsive/Responsive';

function AppHeader() {
  const { isSignedIn, isNativeWebView } = useSelector(state => ({
    isSignedIn: state.user.isSignedIn,
    isNativeWebView: state.ui.isNativeWebView
  }));

  if (!isSignedIn || isNativeWebView) return null;

  return (
    <Responsive mobile desktop desktopLarge={false}>
      <LiveChallengesBar />
    </Responsive>
  );
}

export default AppHeader;
